<template>
  <div class="main">
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/duanqi/banner.jpg"
    ></landingBanner>
    <div class="content">
      <footerForm color="#fe0101" bag="#fe0101" words="提交获取学费报价"></footerForm>
      <div style="width:100%;height:20px;"></div>
       <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/duanqi/p1.jpg">
      </van-image>
       </a>
         <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/duanqi/p2.jpg">
      </van-image>
       </a>
           <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/duanqi/p3.jpg">
      </van-image>
       </a>
        <div class="button" style="padding:10px">
        <van-button color="#fe0101" style="width:100%" to="chat">咨询老师</van-button>
      </div>
          <div style="width:100%;height:20px;"></div>
      <indexTitle title1="成功创业学员" title2="SUCCESSFUL ENTREPRENEURIAL STUDENTS" color="#fe0101"></indexTitle>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/dessert/part5.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
 <div style="width:100%;height:20px;"></div>
       <indexTitle title1="学员评价" title2="我们所有的努力只为了得到你们的认可" color="#fe0101"></indexTitle>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/dessert/talk.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>  
       <indexTitle title1="创就业服务" title2="就业指导，创业帮扶" color="#fe0101"></indexTitle>
       <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/baking6/logo.jpg" />
      <div style="width:100%;height:20px;"></div>
      <footerForm color="#fff" bag="#ea6e74" words="立即获取资料"></footerForm>
    </div>
    <div class="h25px" style="width:100%;height:25px;"></div>
    <foot></foot>
  </div>
</template>

<script>
export default {
  components: {
    back: () => import("../../../components/head/back"),
    landingBanner: () => import("../../../components/common/landing-banner"),
    foot: () => import("@/components/foot/foot"),
    find2: () => import("@/components/common/find2"),
    indexTitle: () => import("@/components/common/indexTitle"),
    footerForm: () => import("@/components/form/footerForm")
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
.content {
  width: 100%;
  background: #fff;
}
</style>